export const SET_PRIVACIES = 'SET_PRIVACIES'
export const REFRESH_PRIVACIES = 'REFRESH_PRIVACIES'
